import { Link } from 'react-router-dom';
import { categories, siteInfo } from '@/mocks/data';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-8 py-14 md:py-20">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-20">
          <div className="lg:w-[380px] flex-shrink-0">
            <Link to="/" className="font-heading text-3xl text-white inline-block">
              黑料吃瓜网
            </Link>
            <p className="mt-6 text-foreground-300 text-sm leading-relaxed">
              {siteInfo.description}
            </p>
            <div className="flex items-center gap-4 mt-6">
              <a href={siteInfo.socialLinks.weibo} className="w-10 h-10 rounded-full border border-foreground-600 flex items-center justify-center text-foreground-400 hover:text-primary-400 hover:border-primary-400 transition-colors" aria-label="微博" rel="nofollow">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href={siteInfo.socialLinks.wechat} className="w-10 h-10 rounded-full border border-foreground-600 flex items-center justify-center text-foreground-400 hover:text-primary-400 hover:border-primary-400 transition-colors" aria-label="微信" rel="nofollow">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href={siteInfo.socialLinks.douyin} className="w-10 h-10 rounded-full border border-foreground-600 flex items-center justify-center text-foreground-400 hover:text-primary-400 hover:border-primary-400 transition-colors" aria-label="抖音" rel="nofollow">
                <i className="ri-tiktok-line text-lg"></i>
              </a>
              <a href={siteInfo.socialLinks.xiaohongshu} className="w-10 h-10 rounded-full border border-foreground-600 flex items-center justify-center text-foreground-400 hover:text-primary-400 hover:border-primary-400 transition-colors" aria-label="小红书" rel="nofollow">
                <i className="ri-booklet-line text-lg"></i>
              </a>
            </div>
          </div>

          <div className="flex-1 grid grid-cols-2 md:grid-cols-3 gap-8">
            <div>
              <h4 className="text-sm font-semibold text-background-50 uppercase tracking-wider">爆料分类</h4>
              <div className="mt-5 space-y-3">
                {categories.map((cat) => (
                  <Link
                    key={cat.slug}
                    to={`/category/${cat.slug}`}
                    className="block text-sm text-foreground-400 hover:text-primary-400 transition-colors"
                  >
                    {cat.name}
                  </Link>
                ))}
              </div>
            </div>
            <div>
              <h4 className="text-sm font-semibold text-background-50 uppercase tracking-wider">快速导航</h4>
              <div className="mt-5 space-y-3">
                <Link to="/" className="block text-sm text-foreground-400 hover:text-primary-400 transition-colors">首页</Link>
                <Link to="/about" className="block text-sm text-foreground-400 hover:text-primary-400 transition-colors">关于我们</Link>
                <a href="#" className="block text-sm text-foreground-400 hover:text-primary-400 transition-colors">投稿爆料</a>
                <a href="#" className="block text-sm text-foreground-400 hover:text-primary-400 transition-colors">加入我们</a>
              </div>
            </div>
            <div>
              <h4 className="text-sm font-semibold text-background-50 uppercase tracking-wider">联系我们</h4>
              <div className="mt-5 space-y-3">
                <p className="text-sm text-foreground-400">{siteInfo.address}</p>
                <p className="text-sm text-foreground-400">{siteInfo.phone}</p>
                <a href={`mailto:${siteInfo.email}`} className="block text-sm text-foreground-400 hover:text-primary-400 transition-colors">
                  {siteInfo.email}
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 黑料吃瓜网 版权所有 | 本站内容均来自网络，如有侵权请联系删除
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors">免责声明</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors">用户协议</a>
          </div>
        </div>
      </div>
    </footer>
  );
}